import { generateXLSX, XLSXRow } from '@retail/products/utils';
import dayjs from 'dayjs';
import { useAppTFunction } from '@retail/app/i18n';
import { AssortmentItemMinimal } from '@retail/my-assortment/types';

const csvData = '\uFEFFMgItem-nummer;MgSupplier-id;Prioritized;Fra-dato;Til-dato;';

const columnOrder = ['mgItemNumber', 'supplierId', 'priority', 'validFrom', 'validTo'];

export const useExportFromBulkEdit = () => {
  const t = useAppTFunction();
  const data: XLSXRow[] = [csvData.split(';')];

  const getSupplierItemsAsRows = (supplierItems: AssortmentItemMinimal[]) => {
    const markupRows: XLSXRow[] = [];

    supplierItems.forEach((supplierItem) => {
      const row: Record<string, string | number | null> = {
        mgItemNumber: supplierItem.mgItemNumber ?? null,
        supplierId: supplierItem.supplier.id,
        priority: supplierItem.priority?.prioritised ? 'Yes' : null,
        validFrom: supplierItem.validFrom
          ? dayjs(supplierItem.validFrom).format('YYYY-MM-DD')
          : null,
        validTo: supplierItem.validTo ? dayjs(supplierItem.validTo).format('YYYY-MM-DD') : null,
      };

      const rowValues = columnOrder.map((key) => row[key]);
      markupRows.push(rowValues);
    });

    return markupRows;
  };

  const exportAsXLSX = async (supplierItems: AssortmentItemMinimal[]) => {
    const updatedData = [...data, ...getSupplierItemsAsRows(supplierItems)];

    try {
      generateXLSX({
        rows: updatedData,
        fileName: `${t('myAssortment.items')}-${dayjs().format('YYYY-MM-DD')}`,
      });
    } catch (error) {
      console.error('Error exporting XLSX:', error);
    }
  };

  return {
    exportAsXLSX,
  };
};
